import { Container, Row, Col } from "react-bootstrap";
import PartnerProgram from "../components/sections/partner-program";
import ChoosePlanModal from "../components/sections/choose-plan-modal";
import { PricingCard } from '@veeyaainnovatives/pricing-card';

import useCustom from "../hooks/useCustom";
import { useState, useEffect } from "react";
import axios from 'axios';
import { getApiUrl } from '../config/api';


const PricingPlans = () => {

    const [plan, setPlan] = useState('');
    const [subscriptions, setSubscriptions] = useState([]);
    const [loading, setLoading] = useState(true);

    const choosePartnerPlan = (myplan, partnerId) => {
        handleShow();
        setPlan(myplan);
        setPartnerId(partnerId);
    }

    const [partnerId, setPartnerId] = useState(null);

    const {
        show,
        handleShow,
        handleClose,
    } = useCustom();

    // Fetch subscriptions from API
    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                setLoading(true);
                const response = await axios.get(getApiUrl('api/public/subscriptions'));

                if (response.data.success && response.data.data) {
                    setSubscriptions(response.data.data);
                } else {
                    setSubscriptions([]);
                }
            } catch (error) {
                console.error('Error fetching subscriptions:', error);
                setSubscriptions([]);
            } finally {
                setLoading(false);
            }
        };

        fetchSubscriptions();
    }, []);
    return (
        <div className="pricing-wrapper pb-5 bg-white">
            <Container>
                <h1 className="about-us-title text-center my-md-5 mt-4">
                    Our <span className="theme-color-green">Pricing Plans</span>
                </h1>

                <Row className="mt-md-5 mt-0 pb-5 g-4 justify-content-center">
                    {loading ? (
                        <Col md={12} className="text-center py-5">
                            <p>Loading pricing plans...</p>
                        </Col>
                    ) : subscriptions.length === 0 ? (
                        <Col md={12} className="text-center py-5">
                            <p>No pricing plans available at the moment.</p>
                        </Col>
                    ) : (
                        subscriptions.map((subscription, index) => {
                            // Determine card variant based on position
                            const variant = index === 0 ? 'left-card' : index === 1 ? 'middle-card' : 'right-card';
                            
                            // Format price function
                            const formatPrice = (price) => {
                                return parseFloat(price).toLocaleString('en-IN', {
                                    maximumFractionDigits: 0
                                });
                            };

                            const handleCardClick = (id, title) => {
                                handleShow();
                                setPlan(title?.toLowerCase() || id);
                                setPartnerId(null); // Clear partner ID when selecting subscription
                            };

                            return (
                                <Col md={4} key={subscription.id}>
                                    <PricingCard
                                        id={subscription.id}
                                        title={subscription.title || 'Plan'}
                                        shortDescription={subscription.short_description}
                                        mainDescription={subscription.main_description}
                                        startPrice={subscription.start_price}
                                        endPrice={subscription.end_price}
                                        priceUnit={subscription.price_unit}
                                        sections={subscription.sections}
                                        buttonText="Get Started"
                                        onButtonClick={handleCardClick}
                                        variant={variant}
                                        formatPrice={formatPrice}
                                    />
                                </Col>
                            );
                        })
                    )}
                </Row>

                <PartnerProgram choosePartnerPlan={choosePartnerPlan} />
            </Container>
            <ChoosePlanModal 
                show={show}
                onHide={() => {
                    handleClose();
                    setPlan('');
                    setPartnerId(null);
                }}
                backdrop="static"
                keyboard={false}
                plan={plan}
                requestType={partnerId ? "partner" : "subscription"}
                refId={partnerId || subscriptions.find(sub => 
                    sub.title?.toLowerCase() === plan?.toLowerCase() || 
                    String(sub.id) === String(plan)
                )?.id || null}
            />
        </div>
    );
};

export default PricingPlans;